import { useEffect, useRef, useState } from "react";
import {
  CasinoPlatform,
  CrashPlatform,
  CricketPlatform,
  FishingPlatform,
  HomeJackpot,
  HotGames,
  SlotPatform,
  TablePlatform,
} from "./CasinoList";
import { useNavigate } from "react-router-dom";
import { isEmpty, lowerCase } from "lodash";
import { apiGet, apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import { isMobile } from "react-device-detect";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/bundle";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { toast } from "react-toastify";
import HomeMatchList from "./HomeMatchList";
const HomeWeb = () => {
  const navigate = useNavigate();
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const launchCasino = useContextSelector(AuthContext, (ctx) => {
    return ctx.launchCasino;
  });
  const [banner, setBanner] = useState([]);
  const [messagelist, setMessageList] = useState([]);

  let getBannerData = async () => {
    const data = await apiPost(apiPath.getBanner, {
      type: "home_top",
      userId: !isEmpty(user) ? user?.user?._id : "",
    });
    if (data?.status == 200) {
      if (data?.data?.success) {
        setBanner(data?.data?.results?.banners);
      }
    }
  };
  const getMessage = async () => {
    const { status, data: response_users } = await apiGet(apiPath.messageList);
    if (status === 200) {
      if (response_users.success) {
        setMessageList(response_users.results);
      }
    }
  };

  useEffect(() => {
    getBannerData();
    getMessage();
  }, []);

  const handel = (res) => {
    if (!isEmpty(user)) {
      if (isEmpty(res?.platFormCode)) {
        toast.error("Comming Soon");
      } else {
        if (!isEmpty(res?.gameid)) {
        } else {
          launchCasino({
            platForm: res?.platFormCode,
            gameType: res?.gameType,
            casinoType: res?.casinoType,
            isLobbyTrue: res?.isLobbyTrue,
          });
        }
      }
    } else {
      navigate("/login");
    }
  };
  return (
    <div className="bg_home">
      <div className="home-banner-box banner-content">
        <div
          className="banner-height hidden-sm-and-down"
          style={{ marginTop: "10px" }}
        >
          {banner?.length > 0 && (
            <Swiper
              style={{ width: isMobile ? "92%" : "50%" }}
              modules={[Autoplay, Navigation]}
              spaceBetween={30}
              autoplay={{ delay: 3000 }}
              loop
              navigation={{
                prevEl: prevRef.current,
                nextEl: nextRef.current,
              }}
              onBeforeInit={(swiper) => {
                swiper.params.navigation.prevEl = prevRef.current;
                swiper.params.navigation.nextEl = nextRef.current;
              }}
            >
              {banner?.map((res) => {
                return (
                  <SwiperSlide>
                    <img
                      src={`${process.env.REACT_APP_API_BASE_URL}${res?.banner_path}`}
                      style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: "15px",
                      }}
                    />
                  </SwiperSlide>
                );
              })}
            </Swiper>
          )}{" "}
          {banner?.length > 0 && (
            <>
              <div
                ref={prevRef}
                className="v-window__prev"
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "10px",
                  zIndex: 5,
                }}
              >
                <button
                  type="button"
                  className="v-btn v-btn--icon v-btn--round theme--dark v-size--default"
                  aria-label="Previous visual"
                >
                  <span className="v-btn__content">
                    <i
                      aria-hidden="true"
                      className="v-icon notranslate mdi mdi-chevron-left theme--dark"
                      style={{ fontSize: "36px" }}
                    />
                  </span>
                </button>
              </div>
              {/* Custom Next Button */}
              <div
                ref={nextRef}
                className="v-window__next"
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "10px",
                  zIndex: 5,
                }}
              >
                <button
                  type="button"
                  className="v-btn v-btn--icon v-btn--round theme--dark v-size--default"
                  aria-label="Next visual"
                >
                  <span className="v-btn__content">
                    <i
                      aria-hidden="true"
                      className="v-icon notranslate mdi mdi-chevron-right theme--dark"
                      style={{ fontSize: "36px" }}
                    />
                  </span>
                </button>
              </div>{" "}
            </>
          )}
        </div>
        {messagelist?.length > 0 && (
          <div
            className="row marquee-row no-gutters"
            style={{
              padding: "1% 12%",
              "background-color": "rgb(21, 9, 46)",
            }}
          >
            <div className="marquee-wrapper">
              <div className="marquee-content">
                {messagelist?.length > 0 &&
                  messagelist?.map((res) => {
                    return (
                      <span className="pr-6 mr-6">
                        {/* <label
                            className="d-inline-block home-announcment-content"
                            style={{ color: "rgb(198, 255, 0)" }}
                          >
                            Scam Alert
                          </label>
                          <label
                            className="d-inline-block home-announcment-content mr-1"
                            style={{ color: "rgb(198, 255, 0)" }}
                          >
                            :
                          </label> */}
                        <label className="d-inline-block home-announcment-content white--text">
                          {res?.message}
                        </label>
                      </span>
                    );
                  })}
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="bg_filter">
        <div className="game-menu py-4">
          <div>
            <div
              id="game-menu-full"
              className="row game-menu-wrapper pb-2 hidden-md-and-up no-gutters"
            >
              <div className="d-flex col col-12">
                <div className="mx-auto">
                  <div
                    tabIndex={0}
                    className="v-card v-card--link v-sheet theme--light game-menu-content font-weight-bold subtitle-1"
                    text
                    depressed
                  >
                    <img
                      src="/static/image/gameTabHolder/jackpot.png"
                      className="side-menu-icon"
                    />
                    <div className="game-menu-title">Jackpot</div>
                  </div>
                </div>
                <div className="mx-auto">
                  <div
                    tabIndex={0}
                    className="v-card v-card--link v-sheet theme--light game-menu-content font-weight-bold subtitle-1 selected"
                    text
                    depressed
                  >
                    <img
                      src="/static/image/gameTabHolder/homepageHot.png"
                      className="side-menu-icon"
                    />
                    <div className="game-menu-title">Hot Games</div>
                  </div>
                </div>
                <div className="mx-auto">
                  <div
                    tabIndex={0}
                    className="v-card v-card--link v-sheet theme--light game-menu-content font-weight-bold subtitle-1"
                    text
                    depressed
                  >
                    <img
                      src="/static/image/gameTabHolder/rng.png"
                      className="side-menu-icon"
                    />
                    <div className="game-menu-title">Slot</div>
                  </div>
                </div>
                <div className="mx-auto">
                  <div
                    tabIndex={0}
                    className="v-card v-card--link v-sheet theme--light game-menu-content font-weight-bold subtitle-1"
                    text
                    depressed
                  >
                    <img
                      src="/static/image/gameTabHolder/ld.png"
                      className="side-menu-icon"
                    />
                    <div className="game-menu-title">casino</div>
                  </div>
                </div>
                <div className="mx-auto">
                  <div
                    tabIndex={0}
                    className="v-card v-card--link v-sheet theme--light game-menu-content font-weight-bold subtitle-1"
                    text
                    depressed
                  >
                    <img
                      src="/static/image/gameTabHolder/crash.png"
                      className="side-menu-icon"
                    />
                    <div className="game-menu-title">Crash</div>
                  </div>
                </div>
                <div className="mx-auto">
                  <div
                    tabIndex={0}
                    className="v-card v-card--link v-sheet theme--light game-menu-content font-weight-bold subtitle-1"
                    text
                    depressed
                  >
                    <img
                      src="/static/image/gameTabHolder/cricket.png"
                      className="side-menu-icon"
                    />
                    <div className="game-menu-title">Cricket</div>
                  </div>
                </div>
                <div className="mx-auto">
                  <div
                    tabIndex={0}
                    className="v-card v-card--link v-sheet theme--light game-menu-content font-weight-bold subtitle-1"
                    text
                    depressed
                  >
                    <img
                      src="/static/image/gameTabHolder/table.png"
                      className="side-menu-icon"
                    />
                    <div className="game-menu-title">Table</div>
                  </div>
                </div>
                <div className="mx-auto">
                  <div
                    tabIndex={0}
                    className="v-card v-card--link v-sheet theme--light game-menu-content font-weight-bold subtitle-1"
                    text
                    depressed
                  >
                    <img
                      src="/static/image/gameTabHolder/fastgames.png"
                      className="side-menu-icon"
                    />
                    <div className="game-menu-title">Fast Games</div>
                  </div>
                </div>
                <div className="mx-auto">
                  <div
                    tabIndex={0}
                    className="v-card v-card--link v-sheet theme--light game-menu-content font-weight-bold subtitle-1"
                    text
                    depressed
                  >
                    <img
                      src="/static/image/gameTabHolder/fishing.png"
                      className="side-menu-icon"
                    />
                    <div className="game-menu-title">Fishing</div>
                  </div>
                </div>
                <div className="mx-auto">
                  <div
                    tabIndex={0}
                    className="v-card v-card--link v-sheet theme--light game-menu-content font-weight-bold subtitle-1"
                    text
                    depressed
                  >
                    <img
                      src="/static/image/gameTabHolder/sb.png"
                      className="side-menu-icon"
                    />
                    <div className="game-menu-title">Sports</div>
                  </div>
                </div>
              </div>
            </div>
            <hr
              role="separator"
              aria-orientation="horizontal"
              className="v-divider theme--light"
            />

            <div className="row mt-0 hidden-md-and-up mobile-provider-card-row left-right-gap">
              <div className="mobile-provider-card-item col gT_homepageHot">
                <div className="v-image v-responsive banner-img theme--light homepageHot_img">
                  <div
                    className="v-responsive__sizer"
                    style={{ "padding-bottom": "100%" }}
                  />
                  <div
                    className="v-image__image v-image__image--preload v-image__image--cover"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content">
                    <img
                      src="/static/image/other/hot-icon.png"
                      className="img-hot-home pos_right_top"
                    />
                  </div>
                </div>
              </div>
              <div className="mobile-provider-card-item col gT_homepageHot">
                <div className="v-image v-responsive banner-img theme--light homepageHot_img">
                  <div
                    className="v-responsive__sizer"
                    style={{ "padding-bottom": "100%" }}
                  />
                  <div
                    className="v-image__image v-image__image--preload v-image__image--cover"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content">
                    <img
                      src="/static/image/other/hot-icon.png"
                      className="img-hot-home pos_right_top"
                    />
                  </div>
                </div>
              </div>
              <div className="mobile-provider-card-item col gT_homepageHot">
                <div className="v-image v-responsive banner-img theme--light homepageHot_img">
                  <div
                    className="v-responsive__sizer"
                    style={{ "padding-bottom": "100%" }}
                  />
                  <div
                    className="v-image__image v-image__image--preload v-image__image--cover"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content">
                    <img
                      src="/static/image/other/hot-icon.png"
                      className="img-hot-home pos_right_top"
                    />
                  </div>
                </div>
              </div>
              <div className="mobile-provider-card-item col gT_homepageHot">
                <div className="v-image v-responsive banner-img theme--light homepageHot_img">
                  <div
                    className="v-responsive__sizer"
                    style={{ "padding-bottom": "100%" }}
                  />
                  <div
                    className="v-image__image v-image__image--preload v-image__image--cover"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content">
                    <img
                      src="/static/image/other/hot-icon.png"
                      className="img-hot-home pos_right_top"
                    />
                  </div>
                </div>
              </div>
              <div className="mobile-provider-card-item col gT_homepageHot">
                <div className="v-image v-responsive banner-img theme--light homepageHot_img">
                  <div
                    className="v-responsive__sizer"
                    style={{ "padding-bottom": "100%" }}
                  />
                  <div
                    className="v-image__image v-image__image--preload v-image__image--cover"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content">
                    <img
                      src="/static/image/other/hot-icon.png"
                      className="img-hot-home pos_right_top"
                    />
                  </div>
                </div>
              </div>
              <div className="mobile-provider-card-item col gT_homepageHot">
                <div className="v-image v-responsive banner-img theme--light homepageHot_img">
                  <div
                    className="v-responsive__sizer"
                    style={{ "padding-bottom": "100%" }}
                  />
                  <div
                    className="v-image__image v-image__image--preload v-image__image--cover"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content">
                    <img
                      src="/static/image/other/hot-icon.png"
                      className="img-hot-home pos_right_top"
                    />
                  </div>
                </div>
              </div>
              <div className="mobile-provider-card-item col gT_homepageHot">
                <div className="v-image v-responsive banner-img theme--light homepageHot_img">
                  <div
                    className="v-responsive__sizer"
                    style={{ "padding-bottom": "100%" }}
                  />
                  <div
                    className="v-image__image v-image__image--preload v-image__image--cover"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content">
                    <img
                      src="/static/image/other/hot-icon.png"
                      className="img-hot-home pos_right_top"
                    />
                  </div>
                </div>
              </div>
              <div className="mobile-provider-card-item col gT_homepageHot">
                <div className="v-image v-responsive banner-img theme--light homepageHot_img">
                  <div
                    className="v-responsive__sizer"
                    style={{ "padding-bottom": "100%" }}
                  />
                  <div
                    className="v-image__image v-image__image--preload v-image__image--cover"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content">
                    <img
                      src="/static/image/other/hot-icon.png"
                      className="img-hot-home pos_right_top"
                    />
                  </div>
                </div>
              </div>
              <div className="mobile-provider-card-item col gT_homepageHot">
                <div className="v-image v-responsive banner-img theme--light homepageHot_img">
                  <div
                    className="v-responsive__sizer"
                    style={{ "padding-bottom": "100%" }}
                  />
                  <div
                    className="v-image__image v-image__image--preload v-image__image--cover"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content">
                    <img
                      src="/static/image/other/hot-icon.png"
                      className="img-hot-home pos_right_top"
                    />
                  </div>
                </div>
              </div>
              <div className="mobile-provider-card-item col gT_homepageHot">
                <div className="v-image v-responsive banner-img theme--light homepageHot_img">
                  <div
                    className="v-responsive__sizer"
                    style={{ "padding-bottom": "100%" }}
                  />
                  <div
                    className="v-image__image v-image__image--preload v-image__image--cover"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content">
                    <img
                      src="/static/image/other/hot-icon.png"
                      className="img-hot-home pos_right_top"
                    />
                  </div>
                </div>
              </div>
              <div className="mobile-provider-card-item col gT_homepageHot">
                <div className="v-image v-responsive banner-img theme--light homepageHot_img">
                  <div
                    className="v-responsive__sizer"
                    style={{ "padding-bottom": "100%" }}
                  />
                  <div
                    className="v-image__image v-image__image--preload v-image__image--cover"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content">
                    <img
                      src="/static/image/other/hot-icon.png"
                      className="img-hot-home pos_right_top"
                    />
                  </div>
                </div>
              </div>
              <div className="mobile-provider-card-item col gT_homepageHot">
                <div className="v-image v-responsive banner-img theme--light homepageHot_img">
                  <div
                    className="v-responsive__sizer"
                    style={{ "padding-bottom": "100%" }}
                  />
                  <div
                    className="v-image__image v-image__image--preload v-image__image--cover"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content">
                    <img
                      src="/static/image/other/hot-icon.png"
                      className="img-hot-home pos_right_top"
                    />
                  </div>
                </div>
              </div>
              <div className="mobile-provider-card-item col gT_homepageHot">
                <div className="v-image v-responsive banner-img theme--light homepageHot_img">
                  <div
                    className="v-responsive__sizer"
                    style={{ "padding-bottom": "100%" }}
                  />
                  <div
                    className="v-image__image v-image__image--preload v-image__image--cover"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content">
                    <img
                      src="/static/image/other/hot-icon.png"
                      className="img-hot-home pos_right_top"
                    />
                  </div>
                </div>
              </div>
              <div className="mobile-provider-card-item col gT_homepageHot">
                <div className="v-image v-responsive banner-img theme--light homepageHot_img">
                  <div
                    className="v-responsive__sizer"
                    style={{ "padding-bottom": "100%" }}
                  />
                  <div
                    className="v-image__image v-image__image--preload v-image__image--cover"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content">
                    <img
                      src="/static/image/other/hot-icon.png"
                      className="img-hot-home pos_right_top"
                    />
                  </div>
                </div>
              </div>
              <div className="mobile-provider-card-item col gT_homepageHot">
                <div className="v-image v-responsive banner-img theme--light homepageHot_img">
                  <div
                    className="v-responsive__sizer"
                    style={{ "padding-bottom": "100%" }}
                  />
                  <div
                    className="v-image__image v-image__image--preload v-image__image--cover"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content">
                    <img
                      src="/static/image/other/hot-icon.png"
                      className="img-hot-home pos_right_top"
                    />
                  </div>
                </div>
              </div>
              <div className="mobile-provider-card-item col gT_homepageHot">
                <div className="v-image v-responsive banner-img theme--light homepageHot_img">
                  <div
                    className="v-responsive__sizer"
                    style={{ "padding-bottom": "100%" }}
                  />
                  <div
                    className="v-image__image v-image__image--preload v-image__image--cover"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content">
                    <img
                      src="/static/image/other/hot-icon.png"
                      className="img-hot-home pos_right_top"
                    />
                  </div>
                </div>
              </div>
              <div className="mobile-provider-card-item col gT_homepageHot">
                <div className="v-image v-responsive banner-img theme--light homepageHot_img">
                  <div
                    className="v-responsive__sizer"
                    style={{ "padding-bottom": "100%" }}
                  />
                  <div
                    className="v-image__image v-image__image--preload v-image__image--cover"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content">
                    <img
                      src="/static/image/other/hot-icon.png"
                      className="img-hot-home pos_right_top"
                    />
                  </div>
                </div>
              </div>
              <div
                id="autoFillEle1"
                className="mobile-provider-card-item gT_homepageHot"
                style={{ "max-height": "0px !important" }}
              >
                <div
                  className="v-image v-responsive  banner-img theme--light"
                  style={{ "max-height": "0px" }}
                >
                  <div
                    className="v-image__image v-image__image--preload v-image__image--cover"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content" />
                </div>
              </div>
              <div
                id="autoFillEle2"
                className="mobile-provider-card-item gT_homepageHot"
                style={{ "max-height": "0px !important" }}
              >
                <div
                  className="v-image v-responsive  banner-img theme--light"
                  style={{ "max-height": "0px" }}
                >
                  <div
                    className="v-image__image v-image__image--preload v-image__image--cover"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content" />
                </div>
              </div>
            </div>
            <div
              className="row mt-0 hidden-md-and-up mobile-provider-card-row"
              style={{ "padding-bottom": "10px" }}
            >
              <div className="mobile-provider-card-item col gT_homepageHot">
                <div className="v-image v-responsive banner-img theme--light">
                  <div
                    className="v-responsive__sizer"
                    style={{ "padding-bottom": "100%" }}
                  />
                  <div
                    className="v-image__image v-image__image--preload v-image__image--contain"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content">
                    <img
                      src="/static/image/other/hot-icon.png"
                      className="img-hot-home pos_right_top"
                    />
                  </div>
                </div>
              </div>
              <div className="mobile-provider-card-item col gT_homepageHot">
                <div className="v-image v-responsive banner-img theme--light">
                  <div
                    className="v-responsive__sizer"
                    style={{ "padding-bottom": "100%" }}
                  />
                  <div
                    className="v-image__image v-image__image--preload v-image__image--contain"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content">
                    <img
                      src="/static/image/other/hot-icon.png"
                      className="img-hot-home pos_right_top"
                    />
                  </div>
                </div>
              </div>
              <div className="mobile-provider-card-item col gT_homepageHot">
                <div className="v-image v-responsive banner-img theme--light">
                  <div
                    className="v-responsive__sizer"
                    style={{ "padding-bottom": "100%" }}
                  />
                  <div
                    className="v-image__image v-image__image--preload v-image__image--contain"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content" />
                </div>
              </div>
              <div className="mobile-provider-card-item col gT_homepageHot">
                <div className="v-image v-responsive banner-img theme--light">
                  <div
                    className="v-responsive__sizer"
                    style={{ "padding-bottom": "100%" }}
                  />
                  <div
                    className="v-image__image v-image__image--preload v-image__image--contain"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content" />
                </div>
              </div>
              <div className="mobile-provider-card-item col gT_homepageHot">
                <div className="v-image v-responsive banner-img theme--light">
                  <div
                    className="v-responsive__sizer"
                    style={{ "padding-bottom": "100%" }}
                  />
                  <div
                    className="v-image__image v-image__image--preload v-image__image--contain"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content">
                    <img
                      src="/static/image/other/new_icon.png"
                      className="img-new-home pos_right_top"
                    />
                  </div>
                </div>
              </div>
              <div className="mobile-provider-card-item col gT_homepageHot">
                <div className="v-image v-responsive banner-img theme--light">
                  <div
                    className="v-responsive__sizer"
                    style={{ "padding-bottom": "100%" }}
                  />
                  <div
                    className="v-image__image v-image__image--preload v-image__image--contain"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content" />
                </div>
              </div>
              <div className="mobile-provider-card-item col gT_homepageHot">
                <div className="v-image v-responsive banner-img theme--light">
                  <div
                    className="v-responsive__sizer"
                    style={{ "padding-bottom": "100%" }}
                  />
                  <div
                    className="v-image__image v-image__image--preload v-image__image--contain"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content">
                    <img
                      src="/static/image/other/new_icon.png"
                      className="img-new-home pos_right_top"
                    />
                  </div>
                </div>
              </div>
              <div className="mobile-provider-card-item col gT_homepageHot">
                <div className="v-image v-responsive banner-img theme--light">
                  <div
                    className="v-responsive__sizer"
                    style={{ "padding-bottom": "100%" }}
                  />
                  <div
                    className="v-image__image v-image__image--preload v-image__image--contain"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content">
                    <img
                      src="/static/image/other/new_icon.png"
                      className="img-new-home pos_right_top"
                    />
                  </div>
                </div>
              </div>
              <div className="mobile-provider-card-item col gT_homepageHot">
                <div className="v-image v-responsive banner-img theme--light">
                  <div
                    className="v-responsive__sizer"
                    style={{ "padding-bottom": "100%" }}
                  />
                  <div
                    className="v-image__image v-image__image--preload v-image__image--contain"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content">
                    <img
                      src="/static/image/other/hot-icon.png"
                      className="img-hot-home pos_right_top"
                    />
                  </div>
                </div>
              </div>
              <div className="mobile-provider-card-item col gT_homepageHot">
                <div className="v-image v-responsive banner-img theme--light">
                  <div
                    className="v-responsive__sizer"
                    style={{ "padding-bottom": "100%" }}
                  />
                  <div
                    className="v-image__image v-image__image--preload v-image__image--contain"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content" />
                </div>
              </div>
              <div className="mobile-provider-card-item col gT_homepageHot">
                <div className="v-image v-responsive banner-img theme--light">
                  <div
                    className="v-responsive__sizer"
                    style={{ "padding-bottom": "100%" }}
                  />
                  <div
                    className="v-image__image v-image__image--preload v-image__image--contain"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content">
                    <img
                      src="/static/image/other/new_icon.png"
                      className="img-new-home pos_right_top"
                    />
                  </div>
                </div>
              </div>
              <div
                id="autoFillEle1"
                className="mobile-provider-card-item gT_rng"
                style={{ "max-height": "0px !important" }}
              >
                <div
                  className="v-image v-responsive  banner-img theme--light"
                  style={{ "max-height": "0px" }}
                >
                  <div
                    className="v-image__image v-image__image--preload v-image__image--cover"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content" />
                </div>
              </div>
              <div
                id="autoFillEle2"
                className="mobile-provider-card-item gT_rng"
                style={{ "max-height": "0px !important" }}
              >
                <div
                  className="v-image v-responsive  banner-img theme--light"
                  style={{ "max-height": "0px" }}
                >
                  <div
                    className="v-image__image v-image__image--preload v-image__image--cover"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content" />
                </div>
              </div>
              <div
                id="autoFillEle3"
                className="mobile-provider-card-item gT_rng"
                style={{ "max-height": "0px !important" }}
              >
                <div
                  className="v-image v-responsive  banner-img theme--light"
                  style={{ "max-height": "0px" }}
                >
                  <div
                    className="v-image__image v-image__image--preload v-image__image--cover"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content" />
                </div>
              </div>
              <div
                id="ldAutoFillEle4"
                className="mobile-provider-card-item gT_ld"
                style={{ "max-height": "0px !important" }}
              >
                <div
                  className="v-image v-responsive  banner-img theme--light"
                  style={{ "max-height": "0px" }}
                >
                  <div
                    className="v-image__image v-image__image--preload v-image__image--cover"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content" />
                </div>
              </div>
            </div>
          </div>
          <div
            className="row mt-0 hidden-sm-and-down mobile-provider-card-row d-flex justify-start align-center no-gutters"
            style={{ gap: "2.2%" }}
          >
            <div className="title_hotGameDesktop col col-12">Hot games</div>
            <div
              className="row align-center no-gutters"
              style={{ width: "100%" }}
            >
              {HotGames?.map((res) => {
                return (
                  <div
                    onClick={() => {
                      if (isEmpty(user)) {
                        navigate("/login");
                      } else {
                        handel(res);
                      }
                    }}
                    className="desktop-provider-card-item pt-3 col gT_homepageHot"
                  >
                    <div className="pa-0 col" style={{ width: "95%" }}>
                      <div className="pa-0 col col-12">
                        <div
                          className="v-image v-responsive banner-img theme--light homepageHot_img"
                          cover
                        >
                          <div
                            className="v-responsive__sizer"
                            style={{ "padding-bottom": "100%" }}
                          />
                          <div
                            className="v-image__image v-image__image--cover"
                            style={{
                              "background-image": `url(${res?.img})`,
                              "background-position": "center center",
                            }}
                          />
                          <div className="v-responsive__content">
                            <div
                              className="v-overlay play-overlay v-overlay--absolute v-overlay--active theme--light"
                              style={{ "z-index": "5" }}
                            >
                              <div
                                className="v-overlay__scrim"
                                style={{
                                  opacity: "0",
                                  "background-color": "rgb(33, 33, 33)",
                                  "border-color": "rgb(33, 33, 33)",
                                }}
                              />
                              <div className="v-overlay__content">
                                <button
                                  type="button"
                                  className="playBtn v-btn v-btn--icon v-btn--round theme--light v-size--default"
                                >
                                  <span className="v-btn__content">
                                    <div
                                      className="v-avatar playBtnIcon"
                                      style={{
                                        height: "60px",
                                        "min-width": "60px",
                                        width: "60px",
                                      }}
                                    >
                                      <img
                                        src="/assets/images/play_btn.svg"
                                        alt
                                      />
                                    </div>
                                  </span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="pa-0 d-flex mt-1 col col-12">
                        <span
                          style={{
                            color: "black",
                            fontWeight: "600",
                            fontSize: "15px",
                          }}
                        >
                          {res?.Name}
                        </span>
                        <span className="text-hot-game">Hot</span>
                      </div>
                      <div className="pa-0 col col-12">
                        <span className="rng_providerLabel">
                          {res?.platFormCode}
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div
              id="autoFillEle1"
              className="mobile-provider-card-item gT_homepageHot"
              style={{ "max-height": "0px !important" }}
            >
              <div
                className="v-image v-responsive  banner-img theme--light"
                style={{ "max-height": "0px" }}
              >
                <div className="v-responsive__content" />
              </div>
            </div>
            <div
              id="autoFillEle2"
              className="mobile-provider-card-item gT_homepageHot"
              style={{ "max-height": "0px !important" }}
            >
              <div
                className="v-image v-responsive  banner-img theme--light"
                style={{ "max-height": "0px" }}
              >
                <div className="v-responsive__content" />
              </div>
            </div>
          </div>
        </div>

        <div className="py-4">
          <div className="row bg-ambas-row pa-2">
            <div
              className="pa-0 bg-ambas col col-12 tabHeight"
              style={{
                "background-image": 'url("/assets/new/bb88_banner-AB.webp")',
              }}
            >
              <div className="col-md-7 ambas hidden-sm-and-down col col-12">
                <div
                  className="v-image v-responsive hidden-md-and-up banner-img theme--light"
                  style={{ height: "100%", width: "100%" }}
                >
                  <div
                    className="v-image__image v-image__image--preload v-image__image--cover"
                    style={{ "background-position": "center center" }}
                  />
                  <div className="v-responsive__content" />
                </div>
                <div className="carousel-controls">
                  <button className="control-dot" />
                  <button className="control-dot" />
                  <button className="control-dot active" />
                  <button className="control-dot" />
                </div>
              </div>
            </div>
          </div>
          <div className="row mx-0 no-gutters justify-center">
            <div className="highlights-container col col-12 pt-8 pb-3">
              <HomeMatchList />
            </div>
          </div>
        </div>
        <div>
          {/* <div
            onClick={() => navigate("/luckywheel")}
            className="v-image v-responsive wofClass theme--light"
            style={{ height: "70px", width: "72px" }}
          >
            <div
              className="v-responsive__sizer"
              style={{ "padding-bottom": "105.521%" }}
            />
            <div
              className="v-image__image v-image__image--cover"
              style={{
                "background-image": 'url("/assets/new/668eb0899634c.gif")',
                "background-position": "center center",
              }}
            />
            <div className="v-responsive__content" />
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default HomeWeb;
